<template>
  <div class="rate-and-suggest">
    <div class="layout">
      <back-button class="back-button" caption="ย้อนกลับ" />
    </div>

    <div class="wiv-body">
      <div class="psb-header">
        <img
          class="psbh-img"
          src="@/assets/images/rate-us.png"
          alt="people-like"
        />
      </div>
      <div class="wivb-title">เราช่วยคุณได้มากแค่ไหน?</div>
      <symbol id="icon-star" class="icon" viewBox="0 0 32 32">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="star"
          class="svg-inline--fa fa-star fa-w-18"
          role="img"
          viewBox="0 0 576 512"
        >
          <path
            fill="currentColor"
            d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
          />
        </svg>
      </symbol>
      <rate
        :length="5"
        v-model="rate"
        class="custom-rating"
        iconref="icon-star"
        :ratedesc="['ปรับปรุง', 'พอใช้', 'เยี่ยม', 'ดี', 'ดีมาก']"
      />
      <div class="wivb-contents">
        <textarea
          class="sr2fbbf-area"
          v-model="tellUs"
          placeholder="มีสิ่งที่อยากบอกเราไหม?"
        ></textarea>
        <material-button
          class="psb-button"
          @clickButton="goNext"
          :disabled="!validate"
          id="send-rate-us"
        >
          ส่งความคิดเห็น
        </material-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RateUs",
  props: ["prevPath"],
  components: {},
  data() {
    const rate = null;
    const tellUs = null;
    return {
      rate,
      tellUs,
    };
  },
  methods: {
    goBack() {
      const hasHistory = window.history.length > 2;
      hasHistory ? this.$router.go(-1) : this.$router.push("/");
    },
    goNext() {
      let payload = {
        rate: this.rate,
        tellUs: this.tellUs,
      };
      this.$store.dispatch("rateUs/addRateUs", payload).then(
        this.$router.push({
          path: "/rating_success",
        })
      );
    },
  },
  computed: {
    validate: function () {
      let valid = false;
      if (this.rate) {
        if (this.tellUs) {
          valid = true;
        }
      }
      return valid;
    },
  },
};
</script>
<style>
.custom-rating {
  height: 60px;
}
.custom-rating :focus {
  outline: none;
}
.custom-rating button {
  color: #f2f3f5;
  padding: 15px 7px;
}
.custom-rating button .icon {
  width: 24px;
  height: 24px;
  margin: 0;
}
.custom-rating :hover {
  background: unset;
}
.custom-rating span {
  color: #acb1bf;
}
</style>

<style scoped>
.rate-and-suggest {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.layout {
  width: 100%;
  padding: 0px 30px;
  max-width: 1120px;
  box-sizing: border-box;
}

.wiv-body {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 736px;
  text-align: center;
  position: relative;
  padding: 0px 30px;
  box-sizing: border-box;
}
.psb-header {
  margin-top: 14px;
  margin-bottom: 28px;
}
.psbh-img {
  width: 201px;
  height: 201px;
}
.wivb-back {
  color: #acb1bf;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 16px;
  width: 100%;
}
.wivbb-img-back {
  margin-right: 10px;
}
.wivb-title {
  width: 100%;
  display: flex;
  font-weight: bold;
  font-size: 28px;
  justify-content: center;
  white-space: nowrap;
}
.wivb-contents {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 58px;
  font-size: 17px;
  margin-bottom: 24px;
}
.psb-button {
  width: 100%;
  max-width: 352px;
  text-align: center;
  color: #ffffff;
  margin-bottom: 14px;
}
.psb-button:hover {
  border: 1px solid #008fc1;
  background-color: #008fc1;
  font-weight: bold;
}
.psb-button:focus {
  outline: none;
}
.psb-button:disabled {
  border: 1px solid #d8d9e0;
  background-color: #d8d9e0;
  color: #b5b6bf;
  pointer-events: none;
  cursor: default;
}
.wivbn-link {
  cursor: pointer;
  color: #6db6f6;
}
.sr2fbbf-area {
  height: 174px;
  width: 100%;
  max-width: 346px;
  border-radius: 4px;
  border: 1px solid #acb1bf;
  margin-bottom: 30px;
  font-family: Noto Sans Thai;
  font-size: 17px;
  padding: 20px;
  box-sizing: border-box;
  resize: none;
}
.sr2fbbf-area::placeholder {
  font-size: 17px;
}

.back-button {
  margin: 24px 0;
}

.Rate__star {
  padding: 0 !important;
}

/*size  >768px */
@media only screen and (min-width: 769px) {
  .sr2fbbf-area {
    max-width: 736px;
  }
  .layout {
    padding: 0 20px;
  }
  .back-button {
    margin-bottom: 0;
  }
  .wiv-body {
    padding: 0;
  }
}
</style>
